export function isQuestionAnswered(question) {
    return question.answer.length > 0;
}
